export default __webpack_public_path__ + "static/media/icon_co2.04f124d5.svg";